export default __webpack_public_path__ + "static/media/AerialFront.cc32e8f6.png";